export { resolveAppData } from './resolve-app-data';
export type {
    AppPageViewModel,
    AppRouteKind,
    AppSeoViewModel,
    AppShellViewModel,
    ResolvedAppData
} from './app-data.types';
